export const ADD_PROFILE = 'ADD_PROFILE'
export const CAMPAIGN = 'CAMPAIGN'
export const THEME = 'THEME'
export const AVATAR = 'AVATAR'